var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBaselineCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8333 4.66663H4.16659C3.01034 4.66663 2.09367 5.59371 2.09367 6.74996L2.08325 19.25C2.08325 20.4062 3.01034 21.3333 4.16659 21.3333H20.8333C21.9895 21.3333 22.9166 20.4062 22.9166 19.25V6.74996C22.9166 5.59371 21.9895 4.66663 20.8333 4.66663ZM20.8333 19.25H4.16659V13H20.8333V19.25ZM20.8333 8.83329H4.16659V6.74996H20.8333V8.83329Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBaselineCreditCard);
export default __webpack_public_path__ + "static/media/ic_baseline-credit-card.2c26543df82cbd82924fcd2c6446b361.svg";
export { ForwardRef as ReactComponent };